function BlankPage(props) {
 
    return null
}

export default BlankPage;
  